"use strict";
var hlp = require('common/helpers');
var Controller = function($scope, $rootScope, $http, $timeout, name) {
  var saveFilter = function(params) {
    localStorage.setItem("thesaurus-" + name + "-filter", JSON.stringify(params));
  };
  $scope.getList = function() {
    $scope.loading = true;
    var params = {
      "query": $scope.query,
      "only_preliminary": $scope.onlyPreliminary,
      "only_parents": $scope.onlyParents,
      "only_categories": $scope.onlyCategories,
      "no_categories": $scope.noCategories,
      "page": $scope.page,
      "per_page": $scope.per_page
    };
    $http.get('/api/thesaurus/' + $scope.name + '/term.json', {params: params}).success(function(data, status, headers, config) {
      $scope.terms = data.terms;
      $scope.count = data.count;
      $scope.title = data.thesaurus.displayName;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
      saveFilter(params);
    });
  };
  $scope.$watch('onlyCategories', function() {
    if ($scope.onlyCategories)
      $scope.noCategories = false;
  });
  $scope.$watch('noCategories', function() {
    if ($scope.noCategories)
      $scope.onlyCategories = false;
  });
  $scope.refresh = function() {
    $scope.page = 1;
    $timeout(function() {
      $scope.getList();
    });
  };
  $scope.range = function(min, max, step) {
    step = step || 1;
    var input = [];
    for (var i = min; i <= max; i += step)
      input.push(i);
    return input;
  };
  $scope.setDisplayMode = function(mode) {
    $scope.displayMode = mode;
    if ($scope.displayMode == 'table') {
      $scope.per_page = 20;
    } else {
      $scope.per_page = 100;
    }
    localStorage.setItem('thesaurus-' + name + '-displayMode', $scope.displayMode);
    $scope.refresh();
  };
  $scope.setPage = function(page) {
    $scope.page = page;
    $scope.getList();
  };
  var initDisplayMode = function() {
    $scope.displayMode = localStorage.getItem('thesaurus-' + name + '-displayMode');
    if ($scope.displayMode == null) {
      $scope.displayMode = 'list';
    }
  };
  $scope.resetFilter = function() {
    localStorage.removeItem("thesaurus-" + name + "-filter");
    initFilterDefaults();
    $scope.getList();
  };
  $scope.$watch('title', function() {
    if (hlp.isSet($scope.title)) {
      window.document.title = $scope.title + " - Thesaurus";
    }
  }, true);
  var initFilterDefaults = function() {
    if ($scope.displayMode == 'table') {
      $scope.per_page = 20;
    } else {
      $scope.per_page = 100;
    }
    $scope.query = "";
    $scope.onlyPreliminary = false;
    $scope.onlyParents = false;
    $scope.page = 1;
  };
  var initFilter = function() {
    var filter = localStorage.getItem("thesaurus-" + name + "-filter");
    if (filter != null) {
      var params = JSON.parse(filter);
      $scope.per_page = params.per_page;
      $scope.query = params.query;
      $scope.onlyPreliminary = params.only_preliminary;
      $scope.onlyParents = params.only_parents;
      $scope.page = params.page;
    }
    var result = document.URL.match(/page=([0-9]+)/);
    if (result != null && result.length > 0 && hlp.isSet(result[1])) {
      $scope.page = parseInt(result[1]);
    }
  };
  var init = function() {
    $scope.name = name;
    $scope.count = 0;
    initDisplayMode();
    initFilterDefaults();
    initFilter();
    $scope.getList();
  }();
};
Controller.$inject = ['$scope', '$rootScope', '$http', '$timeout', 'name'];
module.exports = Controller;
